import ParseUtils from "../utils/parse-utils.ts";
import GroupState from "../enums/group-state.ts";
import MemberState from "../enums/member-state.ts";
import Restaurant from "./restaurant.ts";

export default class Group {
  // general info
  public readonly id: string;
  // TODO - update `code` to `null` on Final Screen for "current group"
  public code: string | null;
  public readonly ownerId: string;
  // User ID -> Member State
  public members: Map<string, MemberState>;
  public state: GroupState;

  // RestaurantApi
  public topRestaurants: Restaurant[] | null;
  public bestRestaurant: string | null;

  constructor(id: string, code: string | null, ownerId: string, members: Map<string, MemberState>, state: GroupState) {
    // general info
    this.id = id;
    this.code = code;
    this.ownerId = ownerId;
    this.members = members;
    this.state = state;

    // RestaurantApi
    this.topRestaurants = null;
    this.bestRestaurant = null;
  }

  public static fromPayload(payload: Record<string, unknown>): Group {
    // id / owner_id
    const id: string = ParseUtils.parseString(payload, "id");
    const owner_id: string = ParseUtils.parseString(payload, "owner_id");

    // code
    let code: string | null = null;
    if (payload["code"] !== undefined && payload["code"] !== null) {
      // coordinates may or may not be set yet
      code = ParseUtils.parseString(payload, "code");
    }

    // members
    const membersRecord: Record<string, unknown> = ParseUtils.parseObject(payload, "members");
    const members: Map<string, MemberState> = new Map<string, MemberState>();
    for (const userId in membersRecord) {
      const memberState: unknown = membersRecord[userId];
      // TODO - type check `memberState`, figure out if it's a proper value of `MemberState`
      members.set(userId, memberState as MemberState);
    }

    // state
    const stateString: string = ParseUtils.parseString(payload, "state");
    // TODO - type check `state`, figure out if it's a proper value of `GroupState`
    const state: GroupState = stateString as GroupState;

    // required fields
    const group: Group = new Group(id, code, owner_id, members, state);

    // top restaurants (optional; dependent on group state)
    group.topRestaurants = Restaurant.parseArrayFromPayload(payload);

    // best restaurant
    let bestRestaurant: string | null = null;
    if (payload["best_restaurant"] !== undefined && payload["best_restaurant"] !== null) {
      // coordinates may or may not be set yet
      bestRestaurant = ParseUtils.parseString(payload, "best_restaurant");
    }
    group.bestRestaurant = bestRestaurant;

    // success
    return group;
  }
}
